import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { buildCrumbs } from '@/lib/breadcrumbs';
import { SITE_ORIGIN } from '@/lib/canonical';

/**
 * BreadcrumbList JSON-LD — non-rendering.
 *
 * Auto-derived from the URL via the same buildCrumbs() helper the visible
 * breadcrumb nav uses. Google reads this to render breadcrumb trails in
 * SERPs, which materially improves inner-page CTR.
 *
 * Mounted once at the layout level (alongside the visual breadcrumb) so
 * it covers every route without any per-page wiring.
 */

const SCRIPT_ID = 'breadcrumb-ld';

export default function BreadcrumbLD() {
  const { pathname } = useLocation();

  useEffect(() => {
    const crumbs = buildCrumbs(pathname);
    // Skip on home (only "Home" crumb) — no list value, and the
    // Organization JSON-LD already covers the homepage.
    if (crumbs.length < 2) {
      const existing = document.getElementById(SCRIPT_ID);
      if (existing) existing.remove();
      return undefined;
    }

    const ld = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: crumbs.map((c, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        name: c.label,
        item: `${SITE_ORIGIN}${c.href}`,
      })),
    };

    let s = document.getElementById(SCRIPT_ID);
    if (!s) {
      s = document.createElement('script');
      s.id = SCRIPT_ID;
      s.type = 'application/ld+json';
      document.head.appendChild(s);
    }
    s.textContent = JSON.stringify(ld);

    return () => {
      const el = document.getElementById(SCRIPT_ID);
      if (el) el.remove();
    };
  }, [pathname]);

  return null;
}
